module.exports = __webpack_public_path__ + "static/media/cmt_icon3.574105b7.png";